import React from 'react'
import { View } from 'reshaped'

export function SplashVideo() {
  return (
    <View
      as="video"
      width="100%"
      height="100%"
      attributes={{
        loop: true,
        src: '/assets/video/splash_video.mp4',
        autoPlay: true,
        playsInline: true,
        muted: true,
        style: {
          objectFit: 'cover',
          width: '100%',
          height: '100%',
        },
      }}
    />
  )
}
